module.exports = __webpack_public_path__ + "static/media/point_kamu.95e24942.svg";